import getColorFromSurfaceVariables from './get-color-from-surface-variables';

const getSurfaceBackground = (surfaceId, variables) => {
  const bgValue = getColorFromSurfaceVariables(surfaceId, 'background_color', variables);
  return `hsl(${bgValue})`;
};

export default getSurfaceBackground;
